import React, {useEffect} from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ItemBanner from "../ItemBanner";

const Banner = ({
    title,
    subtitle,
    description,
    imageMobile,
    imageDesktop,
    catalogUrl,
    catalogText,
    imagePosition = "left",
    articles,
    imageDisclaimer
}) => {
    const hasArticles = Array.isArray(articles) && articles.length > 0;

    const [showArticles, setShowArticles] = React.useState(false);
    const [articulosBanner, setArticulosBanner] = React.useState(null);

    const verArticulosSlide = () => {
        setShowArticles(!showArticles);
    }

    useEffect(() => {
        if (hasArticles) {
            setArticulosBanner([...articles].sort(() => Math.random() - 0.5));
        }
    }, [articles, hasArticles]);

    const imageBlock = (
        <>
            <div className="banner__info--image d-block d-sm-none col-md-7 col-lg-8" style={{ position: "relative" }}>
                <LazyLoadImage
                    alt="banner01"
                    src={imageMobile}
                />
                {
                    imageDisclaimer &&
                        <span style={{ position: "absolute", bottom: "8px", right: "12px", color: "#fff", fontSize: "9px" }}>{imageDisclaimer}</span>
                }
            </div>
            <div className="banner__info--image d-none d-sm-block col-md-7 col-lg-8" style={{ position: "relative" }}>
                <LazyLoadImage
                    alt="banner01"
                    src={imageDesktop}
                />
                {
                    imageDisclaimer &&
                        <span style={{ position: "absolute", bottom: "8px", right: "12px", color: "#fff", fontSize: "12px" }}>{imageDisclaimer}</span>
                }
            </div>
        </>
    );

    const detailBlock = (
        <div className={ imagePosition === "right" ? "banner__info--detail banner__info--detail-reverse col-md-5 col-lg-4" : "banner__info--detail col-md-5 col-lg-4" }>
            <h3>{title}</h3>
            <span>{subtitle}</span>
            <p>{description}</p>
            <div className="ac-btns">
                <button style={{ marginLeft: 0, marginRight: 0 }} className="btn btn-outline-white btn-singleline"
                     onClick={() =>
                        window.open(
                            catalogUrl,
                            "_blank",
                            "noopener,noreferrer"
                        )
                    }
                >
                    {catalogText}
                </button>
                {
                    hasArticles &&
                        <button style={{ marginLeft: 0, marginRight: 0 }} onClick={() => verArticulosSlide()}>Ver</button>
                }
            </div>
        </div>
    );

    const infoClassName = [
        "banner__info",
        showArticles ? "banner__slide" : "active",
        imagePosition === "right" ? "banner__info--reverse" : null
    ].filter(Boolean).join(" ");

    return (
        <div className={ showArticles ? "banner banner--expanded" : "banner" }>
            <div className={infoClassName}>
                {imageBlock}
                {detailBlock}
            </div>
            {
                hasArticles &&
                    <div className={ showArticles ? "banner__articles active" : "banner__articles banner__slide" }>
                        <button className="banner__articles--close" onClick={() => verArticulosSlide()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                        <div className="banner__articles--all">
                            <div className="d-block container_item">
                                {
                                    articulosBanner !== null &&
                                    articulosBanner.map((articulo) =>
                                        <ItemBanner
                                            key={articulo.id}
                                            name={articulo.name}
                                            idArticulo={articulo.id}
                                            imagen={articulo.image}
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
};

export default Banner;
